import React from 'react';
import StudentTooltip from '../StudentTooltip';
import TeacherTooltip from '../TeacherTooltip';
import { SectionRatio } from '../../types';
import './SummaryTable.css';

interface SummaryTableProps {
  sections: SectionRatio[];
  title?: string;
}

const SummaryTable: React.FC<SummaryTableProps> = ({ sections, title }) => {
  return (
    <div className="summary-table-component">
      {title && <h3 className="summary-section-title">{title}</h3>}
      <table className="summary-table">
        <colgroup>
          <col className='class-or-section-name'/>
          <col className='status-text'/>
          <col className='student-count'/>
          <col className='teacher-count'/>
          <col className='required-ratio'/>
        </colgroup>
        <thead>
          <tr>
            <th>Classroom</th>
            <th className="status-header">Status</th>
            <th>S</th>
            <th>T</th>
            <th className="required-ratio-header">Required Ratio</th>
          </tr>
        </thead>
        <tbody>
          {sections.map(section => (
            <React.Fragment key={section.name}>
              <tr className={`section-row ratio-${section.ratioStatus}`}>
                <td className="section-name">{section.name}</td>
                <td className="status-cell nowrap-cell">
                  <span className={`status status-${section.ratioStatus}`}>
                    {section.statusText.toUpperCase()}
                  </span>
                </td>
                <td className="nowrap-cell">{section.totalStudents}</td>
                <td className="nowrap-cell">{section.totalActiveTeachers}</td>
                <td className="nowrap-cell">{section.requiredRatio != 0 ? `${section.requiredRatio} : 1` : "" }</td>
              </tr>
              {section.classrooms.map(classroom => (
                <tr key={classroom.id}>
                  <td>{classroom.name}</td>
                  <td className="status-cell nowrap-cell">
                    <span className={`status status-${classroom.ratioStatus}`}>
                      {classroom.statusText.toUpperCase()}
                    </span>
                  </td>
                  <td className="nowrap-cell">
                    <StudentTooltip students={classroom.students} position="left" classroomId={classroom.id} />
                  </td>
                  <td className="nowrap-cell">
                    <TeacherTooltip teachers={classroom.teachers} classroomId={classroom.id} position="right" />
                  </td>
                  <td className="nowrap-cell">{classroom.requiredRatio != 0 ? `${classroom.requiredRatio} : 1` : "" }</td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SummaryTable;
